import React, { useMemo, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import Summary from './Summary';

import BreadCrumbs from 'components/BreadCrumbs';
import RawData from 'components/RawData';
import Loader from 'components/Loader';
import DashboardContainer from 'components/DashboardContainer';

import { webhookDetails as TEXT } from 'locales/en/webhook';
import { webhookByIdSelector, getWebhookById } from 'redux/slices/webhook';

const WebhookDetail = () => {
  const { id } = useParams();

  const dispatch = useDispatch();
  const { data: webhook, isLoading } = useSelector((state) =>
    webhookByIdSelector(state, id)
  );
  const rawJSON = useMemo(() => {
    return {
      data: JSON.stringify(webhook?.data, null, 2),
      log: JSON.stringify(webhook?.log, null, 2),
      error: JSON.stringify(webhook?.error, null, 2),
    };
  }, [webhook]);

  useEffect(() => {
    if (!isLoading) {
      dispatch(getWebhookById(id));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isLoading) return <Loader />;

  return !!webhook ? (
    <>
      <BreadCrumbs screen="webhook" />
      <DashboardContainer header={`${TEXT.header1} ${id}`}>
        <Summary webhook={webhook} />
        <RawData json={rawJSON.data} title={TEXT.rawDataHeader} />
        <RawData json={rawJSON.log} title={TEXT.log} />
        <RawData json={rawJSON.error} title={TEXT.error} />
      </DashboardContainer>
    </>
  ) : null;
};

export default WebhookDetail;
